/**
 * 申请售后相关API
 */

import request from '@/utils/request'

/**
 * 获取会员列表
 * @params params
 * @returns {AxiosPromise}
 */
export function getAddressList() {
  return request({
    url: `/user/address`,
    method: 'get',
    needToken: true,
    loading: true
  })
}

/**
 * 添加会员地址
 * @params params
 * @returns {AxiosPromise}
 */
export function addAddress(params) {
  return request({
    url: `/user/address`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 修改会员地址
 * @params params
 * @returns {AxiosPromise}
 */
export function editAddress(params) {
  return request({
    url: `/user/address/${params.addr_id}`,
    method: 'put',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 删除会员地址
 * @params params
 * @returns {AxiosPromise}
 */
export function deleteAddress(ids) {
  return request({
    url: `/user/address/${ids}`,
    method: 'delete',
    needToken: true,
    loading: true
  })
}